var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-empty */
import React, { useEffect, useState } from 'react';
import { Dialog } from 'pcln-design-system';
import { QuickActionsStackVariant } from './chatTypes';
import { DefaultModalHeader } from './DefaultModalHeader';
import { ChatDialogMainContentSection } from './ChatDialogContent';
import { ChatbotDataProvider } from './context/ChatbotDataProvider';
import LivePersonCloseChatModalContents from './LivePersonComponents/LivePersonCloseChatModal';
import Survey from './components/Survey/Survey';
var DialogContentWrapper = function (props) {
    var ariaDescription = props.ariaDescription, chatContainerHeight = props.chatContainerHeight, isMobile = props.isMobile, children = props.children;
    useEffect(function () {
        try {
            var dialog = document.querySelector("div[aria-describedby=\"".concat(ariaDescription, "\"]"));
            if (dialog && isMobile) {
                dialog.style.height = 'calc(100% - 25px)';
                dialog.style.margin = '0px';
                dialog.style.marginTop = '25px';
                dialog.style.borderBottomRightRadius = '0px';
                dialog.style.borderBottomLeftRadius = '0px';
                var dialogContentWrapper = dialog.querySelector('div');
                if (dialogContentWrapper) {
                    dialogContentWrapper.style.height = '100%';
                    dialogContentWrapper.style.display = 'block';
                }
            }
            if (dialog && !isMobile) {
                dialog.style.height = chatContainerHeight;
                var dialogContentWrapper = dialog.querySelector('div');
                if (dialogContentWrapper) {
                    dialogContentWrapper.style.height = '100%';
                    dialogContentWrapper.style.display = 'block';
                }
            }
        }
        catch (err) { }
    }, []);
    return React.createElement(React.Fragment, null, children);
};
/**
 * PclnUcChatBot with Dialog overlay
 * @public
 */
export var PclnUcChatBot = function (props) {
    var _a = props.chatContainerHeight, chatContainerHeight = _a === void 0 ? '60%' : _a, dialogOverlayProps = props.dialogOverlayProps, isChatBoxOpened = props.isChatBoxOpened, onClose = props.onClose, setCachedMessages = props.setCachedMessages, setCachedPrompts = props.setCachedPrompts, cachedMessages = props.cachedMessages, cachedPrompts = props.cachedPrompts, submitChatMessagesPayload = props.submitChatMessagesPayload, handleMarkerResponse = props.handleMarkerResponse, fetchRequestOptions = props.fetchRequestOptions, isMobile = props.isMobile, _b = props.markerComponents, markerComponents = _b === void 0 ? {} : _b, discoveryCitySelected = props.discoveryCitySelected, onChatDialogRendered = props.onChatDialogRendered, logFirstMessageSubmitted = props.logFirstMessageSubmitted, logCustomerCarePhoneNumberDisplayed = props.logCustomerCarePhoneNumberDisplayed, logCustomerCarePhoneNumberClicked = props.logCustomerCarePhoneNumberClicked, _c = props.quickActionsStackVariant, quickActionsStackVariant = _c === void 0 ? QuickActionsStackVariant.HORIZONTAL : _c, _d = props.livePersonOptions, livePersonOptions = _d === void 0 ? {} : _d, _e = props.debugMode, debugMode = _e === void 0 ? false : _e, setiValues = props.setiValues;
    var chatbotDataContextValue = {
        chatContainerHeight: chatContainerHeight,
        setCachedMessages: setCachedMessages,
        setCachedPrompts: setCachedPrompts,
        cachedMessages: cachedMessages,
        cachedPrompts: cachedPrompts,
        submitChatMessagesPayload: submitChatMessagesPayload,
        handleMarkerResponse: handleMarkerResponse,
        fetchRequestOptions: fetchRequestOptions,
        markerComponents: markerComponents,
        logFirstMessageSubmitted: logFirstMessageSubmitted,
        logCustomerCarePhoneNumberDisplayed: logCustomerCarePhoneNumberDisplayed,
        logCustomerCarePhoneNumberClicked: logCustomerCarePhoneNumberClicked,
        quickActionsStackVariant: quickActionsStackVariant,
        isMobile: isMobile,
        livePersonOptions: livePersonOptions,
        debugMode: debugMode,
        setiValues: setiValues,
        discoveryCitySelected: discoveryCitySelected,
    };
    var _f = useState(false), showLpCloseModal = _f[0], setShowLpCloseModal = _f[1];
    var _g = useState(false), showSurvey = _g[0], setShowSurvey = _g[1];
    var requestFrom = fetchRequestOptions.headers['x-request-from'];
    var isSurveyEligible = ['travel-itinerary', 'homePage'].includes(requestFrom);
    function handleCloseButton() {
        setShowLpCloseModal(true);
    }
    useEffect(function () {
        if (isChatBoxOpened) {
            onChatDialogRendered();
        }
    }, [isChatBoxOpened]);
    return (React.createElement(ChatbotDataProvider, __assign({}, chatbotDataContextValue),
        React.createElement(Dialog, __assign({ showCloseButton: false, scrimDismiss: true, open: isChatBoxOpened, size: 'lg', onOpenChange: function (isOpen) {
                if (!isOpen) {
                    onClose();
                }
            }, borderRadius: isMobile ? 'lg' : '2xl' }, dialogOverlayProps),
            React.createElement(DialogContentWrapper, __assign({}, dialogOverlayProps, { isMobile: isMobile, chatContainerHeight: chatContainerHeight }),
                React.createElement(DefaultModalHeader, { onClose: function () {
                        if (isSurveyEligible && !showSurvey && (setiValues === null || setiValues === void 0 ? void 0 : setiValues.shouldDisplaySurvey)) {
                            setShowSurvey(true);
                        }
                        else {
                            setShowSurvey(false);
                            onClose();
                        }
                    }, handleCloseButton: handleCloseButton }),
                showSurvey && (setiValues === null || setiValues === void 0 ? void 0 : setiValues.shouldDisplaySurvey) ? (React.createElement(Survey, { onClose: function () {
                        setShowSurvey(false);
                        onClose();
                    }, requestFrom: requestFrom })) : (React.createElement(ChatDialogMainContentSection, null)))),
        React.createElement(Dialog, __assign({ showCloseButton: false, scrimDismiss: false, open: showLpCloseModal, size: 'sm' }, dialogOverlayProps),
            React.createElement(LivePersonCloseChatModalContents, { onClose: setShowLpCloseModal }))));
};
//# sourceMappingURL=PclnUcChatBot.js.map